import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsEngComponent } from './news-eng.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MaterialModule } from 'src/app/material.module';
import { BrowserTransferStateModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { TransferHttpCacheModule } from '@nguniversal/common';
import { NewsEngRoutingModule } from './news-eng-routing.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    HttpClientModule,
    MatSidenavModule,
    NewsEngRoutingModule
  ],
  declarations: [NewsEngComponent]
})
export class NewsEngModule { }
